class ContactSelect {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const Select = $('.js-contact-select');
    $(Select).find('select').on('change', function(){
      if ($(this).val() !== ""){
        $(Select).removeClass('is-empty');
      } else {
        $(Select).addClass('is-empty');
      }
    });

    // URLからクエリパラメータを取得する関数
    function getQueryParam(param) {
      var searchParams = new URLSearchParams(window.location.search);
      return searchParams.get(param);
    }

     // ページロード時に実行
  var programIndex = getQueryParam('program'); // 'program'パラメータの値を取得
  if (programIndex) {
    var selectContainers = document.querySelectorAll('.js-contact-select'); // '.js-contact-select'クラスを持つ全ての要素を取得
    selectContainers.forEach(function(container) {
      container.classList.remove('is-empty'); // 'is-empty'クラスを削除
    });

    var selectElements = document.querySelectorAll('.js-contact-select select'); // '.js-contact-select'内の全てのselect要素を取得
    selectElements.forEach(function(selectElement) {
      var index = parseInt(programIndex, 10);
      if (selectElement.options[index]) {
        selectElement.selectedIndex = index; // セレクトボックスのインデックスを設定
      }
    });
  }

  }
}
